<div class="mat-dialog-wrapper preview-invoice">
  <mat-dialog-content>
      <div class="main-contain">
        <div class="sidenav-header">
            <h2 class="m-0 p-0">
              <span>Annual Accounts</span>
            </h2>
            <div class="d-flex align-items-center gap-15">
              <button
                *ngIf="!data?.isSave && !(!data?.isShowSubmit && data?.charityType === 3)"
                title="Regenerate this document."
                (click)="regenerateClick()"
                class="e-btn cursor-pointer d-flex align-items-center gap-10"
                type="button"
              >
                <mat-icon>refresh</mat-icon>
                Regenerate
              </button>
              <button
              *ngIf="data?.isSave"
              title="Save this document."
              (click)="onSaveClick()"
              class="e-btn cursor-pointer"
              type="button"
            >
              Save
            </button>
              <!-- <mat-icon (click)="downloaReport('Pdf')"  fontSet="material-icons-outlined"  class="cursor-pointer">download</mat-icon> -->
              
              <mat-icon class="close cursor-pointer" mat-dialog-close
                >close</mat-icon
              >
            </div> 
           
        </div>
      </div>

      <div class="content-body inner-table-html p-0" style="min-height: 100%;" (click)="onContentClick($event)">
        <div *ngIf="data?.res" [innerHtml]="safeHtml"></div>
      </div>
  </mat-dialog-content>
</div>